import { render, staticRenderFns } from "./IncidentEditDialog.vue?vue&type=template&id=394d48f9"
import script from "./IncidentEditDialog.vue?vue&type=script&lang=js"
export * from "./IncidentEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports